import { motion } from "framer-motion";

interface MotionProps {
  children: React.ReactNode;
  className?: string;
  delayValue?: number;
  style?: object;
  property?: string;
  onClick?: () => void;
  type: string;
}

export const Motion: React.FC<MotionProps> = ({
  children,
  className,
  delayValue,
  style,
  property,
  onClick,
  type,
}) => {
  let motionProps = {};

  switch (property) {
    case "y":
      motionProps = {
        initial: { opacity: 0, y: -50 },
        animate: { opacity: 1, y: 0 },
        exit: { opacity: 0, x: -50 },
      };
      break;
    case "reverse-y":
      motionProps = {
        initial: { opacity: 0, y: 50 },
        animate: { opacity: 1, y: 0 },
        exit: { opacity: 0, x: 50 },
      };
      break;
    case "x":
      motionProps = {
        initial: { opacity: 0, x: -50 },
        animate: { opacity: 1, x: 0 },
        exit: { opacity: 0, y: -50 },
      };
      break;
    case "reverse-x":
      motionProps = {
        initial: { opacity: 0, x: 50 },
        animate: { opacity: 1, x: 0 },
        exit: { opacity: 0, y: 50 },
      };
      break;
    default:
      motionProps = {};
      break;
  }

  return (
    <>
      {type === "div" && (
        <motion.div
          {...motionProps}
          transition={{ delay: delayValue, ease: "easeIn" }}
          style={style}
          className={className}
          onClick={onClick}
        >
          {children}
        </motion.div>
      )}
      {type === "button" && (
        <motion.button
          {...motionProps}
          transition={{ delay: delayValue, ease: "easeIn" }}
          className={className}
          style={style}
          onClick={onClick}
        >
          {children}
        </motion.button>
      )}
      {type === "p" && (
        <motion.p
          {...motionProps}
          transition={{ delay: delayValue, ease: "easeIn" }}
          className={className}
          style={style}
          onClick={onClick}
        >
          {children}
        </motion.p>
      )}
      {type === "li" && (
        <motion.li
          {...motionProps}
          transition={{ delay: delayValue, ease: "easeIn" }}
          className={className}
          style={style}
          onClick={onClick}
        >
          {children}
        </motion.li>
      )}
    </>
  );
};
